module.exports = __webpack_public_path__ + "images/checkmark-badge.c40ff08208dc7f867f7ad7279ab980a9.svg";